/**
 * @namespace {BX.UI}
 */
export default class ProgressBarColor
{
	static NONE = "ui-progressbar-none";
	static DANGER = "ui-progressbar-danger";
	static SUCCESS = "ui-progressbar-success";
	static PRIMARY = "ui-progressbar-primary";
	static WARNING = "ui-progressbar-warning";
}
